import { render, staticRenderFns } from "./visitors-by-age-and-gender.vue?vue&type=template&id=2b951e08&scoped=true"
import script from "./visitors-by-age-and-gender.vue?vue&type=script&lang=js"
export * from "./visitors-by-age-and-gender.vue?vue&type=script&lang=js"
import style0 from "./visitors-by-age-and-gender.vue?vue&type=style&index=0&id=2b951e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b951e08",
  null
  
)

export default component.exports